import { WebsiteFavicon } from '../../../../components/website-favicon/WebsiteFavicon';

type Props = {
  value: string;
};

export const FaviconCell = (props: Props) => {
  const { value } = props;

  return <WebsiteFavicon website={value} />;
};
